<h2>{{ assessment.title }}</h2>
<div>{{ assessment.uref }}</div>
<div>{{ assessment.description }}</div>
<div class="d-none">{{ assessment.email }}</div>


<h2 i18n="Actions">HEADING_ACTIONS</h2>

<div *ngFor="let a of actions">
  <app-action [action]="a"></app-action>
</div>

<div>&nbsp;</div>

<h2 class="d-none" [innerHTML]="roughcheck.title"></h2>
<div class="d-none" [innerHTML]="roughcheck.description"></div>
<div class="row">
<div class="col-sm-2" i18n="Sponsored by">LABEL_SPONSORED_BY</div>
<div class="col-sm-10"><a
  [href]="roughcheck.website"
  target="_blank">
  <span [innerHTML]="roughcheck.sponsor"></span>
  <span class="fas fa-external-link-alt ml-1"></span></a>
</div>
</div>
<button
  (click)="goPrevious()"
  class="btn btn-secondary"
  i18n="Previous">BUTTON_PREVIOUS</button>
